var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { SmileOutlined } from '@ant-design/icons';
import { Card, Col, Result, Spin, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useGroupService } from '../../../../providers/GroupServiceProvider';
import { useService } from '@tenderd/track-web-utils';
import { i18n } from '../../../../translations';
import { GroupAnalyticsNewTKeys } from '../../../../translations/keys';
import { RequestStatus } from '@tenderd/schema';
import Chart from 'react-apexcharts';
import { parseDate } from '../../../../utils';
var BreakdownByOutcomeCard = function (props) {
    var groupService = useGroupService();
    var service = useService();
    var _a = __read(useState(false), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState([]), 2), breakdownStat = _b[0], setBreakdownStat = _b[1];
    var getRepairStatusLabel = function (request) {
        if (request.status === RequestStatus.Completed &&
            request.completed_at &&
            request.internal) {
            if (new Date(parseDate(request.completed_at)).getTime() -
                new Date(parseDate(request.internal.created_at)).getTime() <
                24 * 60 * 60 * 1000)
                return 'Repaired within 24 hours';
            if (new Date(parseDate(request.completed_at)).getTime() -
                new Date(parseDate(request.internal.created_at)).getTime() <
                48 * 60 * 60 * 1000)
                return 'Repaired between 24 and 48 hours';
            return 'Repaired over 48 hours';
        }
        return 'Unresolved work orders';
    };
    var fetchData = function () {
        service.server
            .getRequestsByGroup(groupService.group.id)
            .then(function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var statuses, counts, arr;
            return __generator(this, function (_a) {
                statuses = data.map(function (a) { return getRepairStatusLabel(a.doc); });
                counts = {};
                statuses.forEach(function (x) {
                    counts[x] = (counts[x] || 0) + 1;
                });
                arr = [];
                Object.keys(counts).forEach(function (key) {
                    arr.push({
                        type: key,
                        value: counts[key],
                    });
                });
                setBreakdownStat(arr.filter(function (a) { return a.value; }));
                setLoading(false);
                return [2 /*return*/];
            });
        }); })
            .catch(function () { return message.error('Error fetching data'); });
    };
    useEffect(function () {
        if (groupService.group) {
            setLoading(true);
            fetchData();
        }
    }, [props.loading, groupService.group]);
    return (React.createElement(Col, { span: 12 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { title: i18n.t(GroupAnalyticsNewTKeys.totalBreakdownByOutcome), headStyle: { fontSize: '16px' }, bodyStyle: { height: '100%' } }, breakdownStat.length &&
                (breakdownStat || []).reduce(function (acc, a) {
                    return acc + a.value;
                }, 0) > 0 ? (React.createElement(Chart, { options: {
                    labels: breakdownStat.map(function (a) { return a.type; }),
                    dataLabels: {
                        enabled: false,
                    },
                }, series: breakdownStat.map(function (a) { return a.value; }), type: "pie", height: 200 })) : (React.createElement(Result, { style: { height: 200 }, icon: React.createElement(SmileOutlined, null), title: "No breakdowns recorded!" }))))));
};
export default BreakdownByOutcomeCard;
